import { useState, type ReactNode } from 'react';
import { Collapse, Group, Paper, Title, UnstyledButton } from '@mantine/core';
import { PiCaretDown, PiCaretRight } from 'react-icons/pi';

type Props = {
  title: ReactNode;
  rightSection?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
};

export function CollapsibleCard({
  title,
  rightSection,
  defaultOpen = true,
  children,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);
  const Icon = open ? PiCaretDown : PiCaretRight;

  return (
    <Paper withBorder p="sm">
      <Group justify="space-between" wrap="nowrap">
        <UnstyledButton onClick={() => setOpen((o) => !o)} style={{ flex: 1 }}>
          <Group gap={6} wrap="nowrap">
            <Icon size={14} color="var(--mantine-color-dimmed)" />
            {typeof title === 'string' ? (
              <Title order={6}>{title}</Title>
            ) : (
              title
            )}
          </Group>
        </UnstyledButton>
        {rightSection}
      </Group>
      <Collapse expanded={open}>
        <div style={{ paddingTop: 'var(--mantine-spacing-xs)' }}>
          {children}
        </div>
      </Collapse>
    </Paper>
  );
}
